class RedirectOnDirective {
  constructor(globalEventBus) {
    this.eventBus = globalEventBus;
  }

  mounted(targetElement, binding) {
    const config = binding?.value;
    const eventName = config?.event;
    const routeTarget = config?.to;
    const condition = config?.condition;

    if (!this.isValidConfig(eventName, routeTarget)) {
      console.warn('[RedirectOnDirective] Configuration invalide', config);
      return;
    }

    const handler = (payload) => {
      if (condition && !condition(payload)) {
        return;
      }

      const router = this.resolveRouter(targetElement);
      if (router) {
        router.push(routeTarget);
      }

      this.eventBus.off(eventName, handler);
    };

    this.eventBus.on(eventName, handler);

    targetElement._redirectHandler = handler;
    targetElement._redirectEvent = eventName;
  }

  unmounted(targetElement) {
    const handler = targetElement._redirectHandler;
    const eventName = targetElement._redirectEvent;

    if (handler && eventName) {
      this.eventBus.off(eventName, handler);
    }

    delete targetElement._redirectHandler;
    delete targetElement._redirectEvent;
  }

  isValidConfig(eventName, routeTarget) {
    return !!(eventName && routeTarget);
  }

  resolveRouter() {
    return window.$router || null;
  }
}

function createRedirectOnDirective(eventBus) {
  const instance = new RedirectOnDirective(eventBus);
  return {
    mounted(targetElement, binding) {
      instance.mounted(targetElement, binding);
    },
    unmounted(targetElement) {
      instance.unmounted(targetElement);
    }
  };
}

export { RedirectOnDirective, createRedirectOnDirective };
